/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowBlockerDtoSchema = z.object({
  document: z.optional(z.string()),
  items: z.optional(z.array(z.string())),
  notes: z.string().nullish(),
});
